import { message } from "antd";
import axiosInstance from "../shared/axios";

const getAllTemplates = async (params) => {
  try {
    const result = await axiosInstance.get("/template/viewAll", {
      params: {
        name: params?.name || "",
        status: params?.status ?? null,
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading templates");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading templates",
    );
    return { data: [], total: 0 };
  }
};

const addEditTemplate = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/template/update" : "/template/create",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save medicines",
    };
  }
};

const deleteTemplate = async (id) => {
  try {
    const result = await axiosInstance.delete(`/template/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete template",
    };
  }
};

const getMedicineLookUp = async () => {
  try {
    let result = await axiosInstance.get("/medicine/options");
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("error", "Error while loading medicine");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading medicine");
    return null;
  }
};

const updateTemplateStatus = async ({ id, IsActive }) => {
  try {
    let result = await axiosInstance?.post(`/template/updateStatus`, {
      id,
      IsActive: Boolean(IsActive),
    });
    if (result?.status === 200 && result?.data?.success) {
      return result?.data;
    } else {
      return {
        success: false,
        message: result?.data?.message || "Failed to update template status",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update template status",
    };
  }
};

export const templateapi = {
  getAllTemplates,
  addEditTemplate,
  deleteTemplate,
  getMedicineLookUp,
  updateTemplateStatus,
};
